var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4573 5.22866L29.2065 6.16666H3.78363L0.416626 0.333328H25.7006C28.258 0.333328 30.1188 2.75883 29.4573 5.22866ZM31.1011 0.333328L32.9375 3.51249L29.882 14.9167H35.9206L39.8278 0.333328H31.1023H31.1011ZM28.4248 9.08333H12.2968C11.1231 9.08333 10.0965 9.87199 9.79196 11.0048L6.40046 23.6667H12.438L14.5251 15.878C14.6768 15.311 15.1901 14.9167 15.777 14.9167H20.8228L18.4778 23.6667H33.5745L35.1378 17.8333H26.0786L28.4236 9.08333H28.4248Z",
    fill: "#FB4C0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.5a6cdd99073676db14336260ceab5e7f.svg";
export { ForwardRef as ReactComponent };